import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const BothSidesDivider = (props) => {
    const { children, className = '' } = props;
    const borderClassName = clsx('flex-grow', 'h-[1px] bg-gray-300');
    return (_jsxs("div", Object.assign({ className: clsx('w-full', 'gap-x-16', 'flex items-center', className) }, { children: [_jsx("div", { className: borderClassName }), children, _jsx("div", { className: borderClassName })] })));
};
